module.exports = __webpack_public_path__ + "img/roaster.e2e19938.svg";